var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "default-layout" },
    [
      _c("cookie-notification"),
      _vm._v(" "),
      _vm.overlayActive ? _c("overlay") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-100 relative", attrs: { id: "viewport" } },
        [
          _c("main-header"),
          _vm._v(" "),
          _vm.currentCatalog === _vm.config.rootcategories.biuro
            ? _c("div", [
                _c("img", {
                  staticClass: "line-office top-line",
                  attrs: { src: "/assets/Line_1.svg", alt: "line" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "line-office bottom-line",
                  attrs: { src: "/assets/Line_2.svg", alt: "line" }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentCatalog === _vm.config.rootcategories.drukowanie
            ? _c("div", [
                _c("img", {
                  staticClass: "ellipse ellipse--blue",
                  attrs: { src: "/assets/ellipse-blue-big.svg", alt: "blue" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "ellipse ellipse--pink",
                  attrs: { src: "/assets/ellipse-pink-big.svg", alt: "blue" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "ellipse ellipse--yellow",
                  attrs: {
                    src: "/assets/ellipse-yellow-small.svg",
                    alt: "blue"
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("async-sidebar", {
            attrs: {
              categoryProps: _vm.currentCatalog,
              "async-component": _vm.SearchPanel,
              "is-open": _vm.isSearchPanelOpen
            },
            on: {
              close: function($event) {
                return _vm.$store.commit("ui/setSearchpanel")
              }
            }
          }),
          _vm._v(" "),
          _c("async-sidebar", {
            attrs: {
              categoryProps: _vm.currentCatalog,
              "async-component": _vm.Microcart,
              "is-open": _vm.isMicrocartOpen
            },
            on: {
              close: function($event) {
                return _vm.$store.commit("ui/setMicrocart")
              }
            }
          }),
          _vm._v(" "),
          _c("async-sidebar", {
            attrs: {
              categoryProps: _vm.currentCatalog,
              "async-component": _vm.SidebarMenu,
              "is-open": _vm.isSidebarOpen,
              direction: "left"
            },
            on: {
              close: function($event) {
                return _vm.$store.commit("ui/setSidebar")
              }
            }
          }),
          _vm._v(" "),
          _c("async-sidebar", {
            attrs: {
              categoryProps: _vm.currentCatalog,
              "async-component": _vm.Wishlist,
              "is-open": _vm.isWishlistOpen
            },
            on: {
              close: function($event) {
                return _vm.$store.commit("ui/setWishlist")
              }
            }
          }),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.officeInfo },
            [
              _vm.currentCatalog === _vm.config.rootcategories.biuro
                ? _c("cms-block-chunk", {
                    staticClass: "contact_phone",
                    attrs: { identifier: "c_CONTACT_PHONE" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentCatalog === _vm.config.rootcategories.drukowanie
                ? _c("cms-block-chunk", {
                    staticClass: "contact_phone",
                    attrs: { identifier: "c_CONTACT_PHONE_2" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("main-footer"),
          _vm._v(" "),
          _c("notification"),
          _vm._v(" "),
          _c("sign-up", { attrs: { categoryProps: _vm.currentCatalog } }),
          _vm._v(" "),
          _c("offline-badge"),
          _vm._v(" "),
          _vm.loadOrderConfirmation
            ? _c("order-confirmation", {
                attrs: { "orders-data": _vm.ordersData }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("vue-progress-bar")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }